export const paginationDefaults = { limit: 1000, offset: 0 };
